function getClosestNumberArrayUtil (arr, val) {
  return [...arr].sort(
    (a, b) => Math.abs(val - a) - Math.abs(val - b)
  )[0]
}

export {
  getClosestNumberArrayUtil
}
